import PropTypes from "prop-types";
import React from "react";

import Container from "../container";

import classes from "./blogpost.module.css";
import "./normalize.css";
import "./global.css";

const Blogpost = ({ children }) => {
  return (
    <div>
      <Container>{children}</Container>
      <div className={classes.blobMain}>
       <svg
        className={classes.svg}
        width="504"
        height="784"
        fill="none"
        viewBox="0 0 604 784"
      >
        <defs>
          <pattern
            id="5d0dd344-b041-4d26-bec4-8d33ea57ec9b"
            x="0"
            y="0"
            width="20"
            height="20"
            patternUnits="userSpaceOnUse"
          >
            <rect
              x="0"
              y="0"
              width="4"
              height="4"
              className="text-gray-200"
              fill="#3586ea"
            />
          </pattern>
        </defs>
        <rect
          width="404"
          height="784"
          fill="url(#5d0dd344-b041-4d26-bec4-8d33ea57ec9b)"
        />
      </svg>
      </div>
    </div>
  );
};

Blogpost.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Blogpost;
